export default {"src":"/_next/static/media/mds.2a99fdca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};